import * as React from "react";
const SvgSwitchBasicOval = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props}>
    <circle cx={14} cy={14} r={14} fill="#fff" />
  </svg>
);
export default SvgSwitchBasicOval;
